module.exports = __webpack_public_path__ + "media/images/barbecue-daaa61e4fc9294a8845f2399408452e7.svg";